import { Injectable, HostListener } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";

import Swal from "sweetalert2";
const SESSION_TIME = 30; // Set the session timeout duration in minutes
let sessionTimer: any;
let loginTime: Date = new Date();
@Injectable({
  providedIn: "root",
})
export class SessionTimeoutService {
  private timeoutId: any;
  private alreadyAlert: boolean = false;
  // private readonly sessionTimeoutMinutes = 30;
  // private readonly logoutUrl = "/logout"; // Specify the logout URL

  constructor(private router: Router, private modalService: NgbModal) {
    this.setupEventListeners();
    this.startSessionTimer();
  }

  private setupEventListeners(): void {
    window.addEventListener("touchstart", () => {
      this.ResetTime();
    });

    window.addEventListener("mousemove", () => {
      this.ResetTime();
    });

    window.addEventListener("keydown", () => {
      this.ResetTime();
    });

    document.addEventListener("visibilitychange", () => {
      if (!document.hidden) {
        this.startSessionTimer();
      }
    });
  }

  private startSessionTimer() {
    sessionTimer = setInterval(() => {
      const currentTime = new Date();
      const elapsedTime = (currentTime.getTime() - loginTime.getTime()) / 1000;
      if (
        (elapsedTime > SESSION_TIME * 60 && !this.alreadyAlert) &&
        this.router.url != "/login"
      ) {
        this.clearTime();
        this.sweetAlertPopup();
      }
    }, 1000);
  }

  private sweetAlertPopup() {
    this.alreadyAlert = true;
    return Swal.fire({
      title: "Session Timeout",
      text: "Your session has timed out. Please log in again.",
      imageUrl: "assets/img/brand/logo.png",
      imageWidth: 125,
      imageHeight: 125,
      showConfirmButton: true,
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Log out",
    }).then(() => {
      this.logout();
    });
  }

  ResetTime() {
    this.clearTime();
    loginTime = new Date();
    this.startSessionTimer();
  }

  clearTime() {
    clearInterval(sessionTimer);
  }

  logout(): void {
    this.modalService.dismissAll();
    localStorage.clear();
    this.router.navigate(["/login"]);
    this.alreadyAlert = false;
    this.clearTime();
  }
}
